import axios, {AxiosResponse} from 'axios'

// lecturer statistics
const lecturerStatistics = async () => {
  const response = await axios.get('/api/lecturer/statistics')
  return response.data
}

// List lecturer
const lecturerList = async ({params}) => {
  const response = await axios.get('/api/lecturer/list', params)
  return response.data
}

// Create Or Update new lecturer
const lecturerCreate = async ({data}) => {
  await axios.post('/api/lecturer/store', data)
}

// Edit lecturer
const lecturerEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/lecturer/edit/${id}`)
  return response.data
}

// Email to lecturer active students
const lecturerEmail = async ({data}) => {
  await axios.post('/api/lecturer/email', data)
}

// Delete lecturer
const lecturerDelete = async (id: string) => {
  await axios.get(`/api/lecturer/destroy/${id}`)
}

// Toggle Archive lecturer
const lecturerToggleArchive = async (id: string) => {
  await axios.get(`/api/lecturer/toggle-archive/${id}`)
}

// List Archived lecturer
const archivedLecturerList = async ({params}) => {
  const response = await axios.get('/api/lecturer/archived-list', params)
  return response.data
}

// lecturerView
const lecturerView = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/lecturer/view/${id}`)
  return response.data
}

// List lecturerDocument
const lecturerDocumentList = async ({params}) => {
  const response = await axios.get('/api/lecturer-document/list', params)
  return response.data
}

// Create Or Update new lecturerDocument
const lecturerDocumentCreate = async ({data}) => {
  await axios.post('/api/lecturer-document/store', data)
}

// Edit lecturerDocument
const lecturerDocumentEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/lecturer-document/edit/${id}`)
  return response.data
}

// Delete lecturerDocument
const lecturerDocumentDelete = async (id: string) => {
  await axios.get(`/api/lecturer-document/destroy/${id}`)
}

const publicationList = async ({params}) => {
  const response = await axios.get('/api/lec-portal/publication-list', params)
  return response.data
}

const lecturerRegulations = async () => {
  const response = await axios.get('/api/lec-portal/regulations')
  return response.data
}

const myVidLibrary = async () => {
  const response = await axios.get('/api/lec-portal/video-library')
  return response.data
}

const videoSearch = async (
  type: string,
  program_level: string,
  section: string
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(
    `/api/lec-portal/video-search/${type}/${program_level}/${section}`
  )
  return response.data
}

const lecturerProfile = async () => {
  const response = await axios.get('/api/lec-portal/my-profile')
  return response.data
}

// List lecturerDocument
const myDocumentList = async () => {
  const response = await axios.get('/api/lec-portal/my-docs')
  return response.data
}

// Create Or Update new lecturerDocument
const myDocumentCreate = async ({data}) => {
  await axios.post('/api/lec-portal/doc-store', data)
}

const myPublicationList = async () => {
  const response = await axios.get('/api/lec-portal/pub-list')
  return response.data
}

// Create Or Update publication
const myPublicationCreate = async ({data}) => {
  await axios.post('/api/lec-portal/pub-store', data)
}

const myCourses = async () => {
  const response = await axios.get('/api/lec-portal/my-courses')
  return response.data
}

const myCourseStudents = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/my-students/${id}`)
  return response.data
}

const studentAttendance = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/student-attendance/${id}`)
  return response.data
}

const getAttendance = async ({data}) => {
  const response = await axios.post(`/api/lec-portal/get-attendance`, data)
  return response.data
}

const studentAttendancePrint = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/print-attendance/${id}`)
  return response.data
}

const studentScores = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/student-scores/${id}`)
  return response.data
}

const storeScore = async ({data}) => {
  const response = await axios.post(`/api/lec-portal/store-scores`, data)
  return response.data
}

const studentScorePrint = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/print-score/${id}`)
  return response.data
}

const storeRedoRetake = async ({data}) => {
  const response = await axios.post(`/api/lec-portal/store-redo-retake`, data)
  return response.data
}

const studentAssignments = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/student-assignments/${id}`)
  return response.data
}

const listOnlineClasses = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/list-online-classes/${id}`)
  return response.data
}
const getCourseDates = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/get-course-dates/${id}`)
  return response.data
}

const storeOnlineClass = async ({data}) => {
  const response = await axios.post(`/api/lec-portal/store-online-class`, data)
  return response.data
}

const onlineClassDelete = async (id: string) => {
  await axios.get(`/api/lec-portal/online-class-destroy/${id}`)
}

const evForm = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/course-ev-form/${id}`)
  return response.data
}

const annualFeeback = async () => {
  const response = await axios.get('/api/lec-portal/annual-form')
  return response.data
}

const getAnnualFeeback = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/get-annual-form/${id}`)
  return response.data
}

const storeAnnualForm = async ({data}) => {
  const response = await axios.post('/api/lec-portal/annual-form-store', data)
  return response.data
}

const lecturerFeedbackReport = async (id: string) => {
  const response = await axios.get(`/api/lecturer/feedback-report/${id}`)
  return response.data
}
const myProfileEdit = async () => {
  const response = await axios.get(`/api/lec-portal/profile-edit`)
  return response.data
}

const myProfileUpdate = async ({data}) => {
  const response = await axios.post('/api/lec-portal/profile-update', data)
  return response.data
}

const scheduleAcademicYears = async () => {
  const response = await axios.get(`/api/lecturer-contract/schedule-academic-years`)
  return response.data
}

const academicYearSemesters = async (id: string) => {
  const response = await axios.get(`/api/lecturer-contract/academic-year-semesters/${id}`)
  return response.data
}

const semesterLecturers = async (id: string) => {
  const response = await axios.get(`/api/lecturer-contract/semester-lectures/${id}`)
  return response.data
}

const lecturerCourses = async ({data}) => {
  const response = await axios.post(`/api/lecturer-contract/lecturer-courses`, data)
  return response.data
}

const lecturerContractStore = async ({data}) => {
  const response = await axios.post('/api/lecturer-contract/store', data)
  return response.data
}

const lecturerContractList = async ({params}) => {
  const response = await axios.get('/api/lecturer-contract/list', params)
  return response.data
}

const contractDelete = async (id: string) => {
  await axios.get(`/api/lecturer-contract/destroy/${id}`)
}

const contractOptions = async () => {
  const res = await axios.get(`/api/lecturer-contract/contract-options`)
  return res.data
}

const contractDetails = async (id: string) => {
  const response = await axios.get(`/api/lecturer-contract/view/${id}`)
  return response.data
}

const myContracts = async () => {
  const res = await axios.get(`/api/lec-portal/my-contracts`)
  return res.data
}

const signContract = async ({data}) => {
  const response = await axios.post(`/api/lec-portal/sign-contract`, data)
  return response.data
}

const mgrSignContract = async ({data}) => {
  const response = await axios.post(`/api/lecturer-contract/sign-contract`, data)
  return response.data
}

const editContractComment = async (id: string) => {
  const response = await axios.get(`/api/lec-portal/edit-comment/${id}`)
  return response.data
}

const updateContractComment = async ({data}) => {
  const response = await axios.post(`/api/lec-portal/update-comment`, data)
  return response.data
}

const getContractComment = async (id: string) => {
  const response = await axios.get(`/api/lecturer-contract/get-contract-comment/${id}`)
  return response.data
}

const lecturerNews = async () => {
  const response = await axios.get(`/api/lec-portal/my-news`)
  return response.data
}

const emailContract = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/lecturer-contract/email/${id}`)
  return response.data
}

const getLecList = async () => {
  const response = await axios.get(`/api/lecturer/get-lecturers`)
  return response.data
}

const createUserForLecs = async ({data}) => {
  const response = await axios.post('/api/lecturer/create-user', data)
  return response.data
}

const updateAndEmailLecturerAccount = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/lecturer/update-email-account/${id}`)
  return response.data
}

const lecturerService = {
  updateAndEmailLecturerAccount,
  createUserForLecs,
  getLecList,
  emailContract,
  lecturerNews,
  getContractComment,
  editContractComment,
  updateContractComment,
  lecturerStatistics,
  signContract,
  mgrSignContract,
  myContracts,
  contractDetails,
  contractOptions,
  contractDelete,
  lecturerContractList,
  lecturerContractStore,
  lecturerCourses,
  semesterLecturers,
  academicYearSemesters,
  scheduleAcademicYears,
  myProfileUpdate,
  myProfileEdit,
  lecturerFeedbackReport,
  annualFeeback,
  getAnnualFeeback,
  storeAnnualForm,
  evForm,
  onlineClassDelete,
  storeOnlineClass,
  getCourseDates,
  listOnlineClasses,
  studentAssignments,
  storeRedoRetake,
  studentScorePrint,
  storeScore,
  studentScores,
  studentAttendancePrint,
  getAttendance,
  studentAttendance,
  myCourseStudents,
  myCourses,
  myPublicationList,
  myPublicationCreate,
  myDocumentList,
  myDocumentCreate,
  lecturerProfile,
  videoSearch,
  myVidLibrary,
  lecturerRegulations,
  publicationList,
  lecturerList,
  lecturerCreate,
  lecturerEdit,
  lecturerEmail,
  lecturerDelete,
  lecturerToggleArchive,
  archivedLecturerList,
  lecturerView,
  lecturerDocumentList,
  lecturerDocumentCreate,
  lecturerDocumentEdit,
  lecturerDocumentDelete,
}

export default lecturerService
